export var themeColorsArray = [
    'text',
    'primary',
    'secondary',
    'error',
    'success',
    'info',
    'warning',
    'disabledLight',
    'disabledDark',
    'disabledGrey',
    'accentBlue',
    'accentBlue50',
    'accentBlue100',
    'accentBlue200',
    'accentBlue300',
    'accentBlue400',
    'accentBlue500',
    'accentBlue600',
    'accentBlue700',
    'accentBlue800',
    'accentBlue900',
    'black',
    'white',
    'gray',
    'gray50',
    'gray100',
    'gray200',
    'gray300',
    'gray400',
    'gray500',
    'gray600',
    'gray700',
    'gray800',
    'gray900',
    'green',
    'green50',
    'green100',
    'green200',
    'green300',
    'green400',
    'green500',
    'green600',
    'green700',
    'green800',
    'green900',
    'blue',
    'blue50',
    'blue100',
    'blue200',
    'blue300',
    'blue400',
    'blue500',
    'blue600',
    'blue700',
    'blue800',
    'blue900',
    'blueGray',
    'blueGray50',
    'blueGray100',
    'blueGray200',
    'blueGray300',
    'blueGray400',
    'blueGray500',
    'blueGray600',
    'blueGray700',
    'blueGray800',
    'blueGray900',
    'red',
    'red50',
    'red100',
    'red200',
    'red300',
    'red400',
    'red500',
    'red600',
    'red700',
    'red800',
    'red900',
    'slate50',
    'slate100',
    'slate200',
    'slate300',
    'slate400',
    'slate500',
    'slate600',
    'slate700',
    'slate800',
    'slate900',
];
export var spacerKeys = ['xxs', 'xs', 'small', 'medium', 'large', 'xl', 'xxl'];
//# sourceMappingURL=theme.js.map